<template>
  <router-view></router-view>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        outcomePlan: "businessOutcomePlans/current",
        outcomePlanLoading: "businessOutcomePlans/currentLoading",
        currentUserData: "auth/currentUserData",
      }),
    },
    props: {
      source: String,
    },
    watch: {
      $route: function () {
        this.handleRoute();
      },
      selectedOutcome: function () {
        this.initOutcomePlan();
      },
    },
    data: () => ({
      selectedOutcome: null,
    }),
    mounted() {
      this.handleRoute();
    },
    methods: {
      handleRoute() {
        if (
          !this.$route.params.outcomesID &&
          this.$route.path != "/outcomePlans"
        ) {
          this.goToOutcomeSelection();
        } else {
          // If Outcome Selected, Initialize the Outcome
          this.initOutcome();
        }
      },
      async initOutcome() {
        if (this.outcomesList.length < 1) {
          await this.$store.dispatch("outcomes/loadAll");
        }
        let outcome = this.outcomesList.find(
          (e) => e.id == this.$route.params.outcomesID
        );

        // If outcome found then set the selected outcome, otherwise go to Outcome Selection
        if (outcome) {
          this.selectedOutcome = outcome;
          this.$store.dispatch(
            "businessOutcomePlans/updateSelectedOutcome",
            outcome
          );
        } else {
          this.goToOutcomeSelection();
        }
      },
      async initOutcomePlan() {
        if (
          !this.outcomePlan ||
          this.outcomePlan.outcome_id != this.selectedOutcome.id
        ) {
          await this.$store.dispatch(
            "businessOutcomePlans/loadByOutcomeID",
            this.selectedOutcome.id
          );
        }
      },

      goToOutcomeSelection() {
        this.$router.push("/outcomePlans");
        this.$store.dispatch("businessOutcomePlans/updateSelectedOutcome", null);
      },
      goToOutcomeQuestionnaire() {
        this.$router.push("/outcomePlans");
      },
      goToOutcomeDataEntry() {
        this.$router.push("/outcomePlans");
      },
    },
  };
</script>
